import { createSlice } from "@reduxjs/toolkit";
import {  getRewards, getTopTargetGroup, getTotalTargetGroup, getTotalTargetGroupBranch, getTotalTargetGroupDate } from "../../api/dashboard/dashboard";

const initialState = {
  totalGroup: null,
  chartBar:null,
  topGroup:null,
  chartPie:null,
  rewards: null,
  isLoading: false,
  isLoadChartBar:false,
  isLoadTopGroup:false,
  isLoadChartPie:false,
  isLoadRewards:false
};

const dashboard = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTotalTargetGroup.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTotalTargetGroup.fulfilled, (state, action) => {
        state.totalGroup = action?.payload;
        state.isLoading = false;
      })
      .addCase(getTotalTargetGroup.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action?.error;
      })
      .addCase(getTotalTargetGroupDate.pending, (state) => {
        state.isLoadChartBar = true;
      })
      .addCase(getTotalTargetGroupDate.fulfilled, (state, action) => {
        state.chartBar = action?.payload;
        state.isLoadChartBar = false;
      })
      .addCase(getTotalTargetGroupDate.rejected, (state, action) => {
        state.isLoadChartBar = false;
        state.error = action?.error;
      })
      .addCase(getTopTargetGroup.pending, (state) => {
        state.isLoadTopGroup = true;
      })
      .addCase(getTopTargetGroup.fulfilled, (state, action) => {
        state.topGroup = action?.payload;
        state.isLoadTopGroup = false;
      })
      .addCase(getTopTargetGroup.rejected, (state, action) => {
        state.isLoadTopGroup = false;
        state.error = action?.error;
      })
      .addCase(getTotalTargetGroupBranch.pending, (state) => {
        state.isLoadChartPie = true;
      })
      .addCase(getTotalTargetGroupBranch.fulfilled, (state, action) => {
        state.chartPie = action?.payload;
        state.isLoadChartPie = false;
      })
      .addCase(getTotalTargetGroupBranch.rejected, (state, action) => {
        state.isLoadChartPie = false;
        state.error = action?.error;
      })
      .addCase(getRewards.pending, (state) => {
        state.isLoadRewards = true;
      })
      .addCase(getRewards.fulfilled, (state, action) => {
        state.rewards = action?.payload;
        state.isLoadRewards = false;
      })
      .addCase(getRewards.rejected, (state, action) => {
        state.isLoadRewards = false;
        state.error = action?.error;
      })
  },
});

export const {} = dashboard.actions;

export default dashboard.reducer;
